import angular from 'angular';
import _ from 'lodash';

angular.module('webTools').service('DropHandler', ['$q',
    function ($q) {
        return {
            getFiles: function (dataTransfer) {
                var defer = $q.defer();
                var files = [];
                var items = dataTransfer.items;
                var pendingPromises = [];

                const readEntriesRecursive = function (reader, fullPath) {
                    var subDefer = $q.defer();

                    reader.readEntries(function (entries) {
                        if (entries.length === 0) {
                            subDefer.resolve();
                            return;
                        }

                        let subPromises = _.map(entries, function (entry) {
                            return processEntry(entry, fullPath);
                        });

                        $q.all(subPromises).then(() => {
                            readEntriesRecursive(reader, fullPath).then(() => {
                                subDefer.resolve();
                            });
                        });
                    });

                    return subDefer.promise;
                };

                const processEntry = function (entry, parentPath) {
                    var subDefer = $q.defer();

                    if (entry.isDirectory) {
                        let reader = entry.createReader();
                        readEntriesRecursive(reader, `${parentPath}/${entry.name}`).then(() => {
                            subDefer.resolve();
                        });
                    } else {
                        entry.file(function (file) {
                            file.relativePath = `${parentPath}/${file.name}`.substring(1);
                            files.push(file);
                            subDefer.resolve();
                        }, function (error) {
                            console.error('Error reading file:', error);
                            subDefer.resolve();
                        });
                    }

                    return subDefer.promise;
                };

                if (items && items[0] && items[0].webkitGetAsEntry) {
                    let filteredItems = _.reject(items, item => item.kind === 'string');

                    _.each(filteredItems, function (item) {
                        let entry = item.webkitGetAsEntry();
                        if (entry) {
                            pendingPromises.push(processEntry(entry, ''));
                        }
                    });

                    $q.all(pendingPromises).then(() => {
                        defer.resolve(files);
                    });

                } else {
                    _.forEach(dataTransfer.files, function (file) {
                        files.push(file);
                    });
                    defer.resolve(files);
                }

                return defer.promise;
            }
        }
    }
]);
